module.exports = __webpack_public_path__ + "static/media/bank1.febe99fa.png";